'use client';
import type { CSSProperties, ReactElement } from 'react';
import { ButtonPreset } from '@/constants/componentPresets';
import { dataEl, type DataElScope } from '@/utils/dataEl';
import { MessageModalPrimaryButton } from './MessageModalPrimaryButton';
import { MessageModalSecondaryButton } from './MessageModalSecondaryButton';
interface MessageModalFooterProps {
    dataElScope: DataElScope;
    loading: boolean;
    primaryLoading: boolean;
    primaryButtonText?: string;
    primaryButtonPreset: ButtonPreset;
    secondaryButtonText?: string;
    footerStyle: CSSProperties;
    footerButtonStyle: CSSProperties;
    footerButtonPadding?: string;
    footerButtonHeight?: number;
    onPrimaryClick: () => void;
    onSecondaryClick: () => void;
}
export function MessageModalFooter({ dataElScope, loading, primaryLoading, primaryButtonText, primaryButtonPreset, secondaryButtonText, footerStyle, footerButtonStyle, footerButtonPadding, footerButtonHeight, onPrimaryClick, onSecondaryClick, }: MessageModalFooterProps): ReactElement {
    return (
      <div data-el={dataEl(dataElScope, 'Footer/Root')} style={footerStyle}>
        <MessageModalPrimaryButton dataElScope={dataElScope} label={primaryButtonText} preset={primaryButtonPreset} loading={loading || primaryLoading} padding={footerButtonPadding} height={footerButtonHeight} style={footerButtonStyle} onClick={onPrimaryClick}/>

        <MessageModalSecondaryButton dataElScope={dataElScope} label={secondaryButtonText} loading={loading} padding={footerButtonPadding} height={footerButtonHeight} style={footerButtonStyle} onClick={onSecondaryClick}/>
      </div>
    );
}
